import { hotelFundedOffersApi } from "./api";

export const hotelFundedOffersReducers = {
  [hotelFundedOffersApi.reducerPath]: hotelFundedOffersApi.reducer,
};

export const hotelFundedOffersApiMiddlewares = [
  hotelFundedOffersApi.middleware,
];

export { hotelFundedOffersApi };
export * from "./api";
